export const validationService ={
    forgotPasswordValidation(data, sentOtp = false){
        const errors ={}
        if(!data.email?.trim()){
            errors.email = "Email is required"
        }else if(!this.isValidEmail(data.email)){
            errors.email = "Invalid Email Address"
        }
        
        if(sentOtp){
            if(!data.otp?.trim()){
                errors.otp = "OTP required"
            }else if(!this.isOnlyNumbers(data.otp)){
                errors.otp = "Please Enter the Numbers only"
            }
            else if(data.otp.length !== 4){
                errors.otp = "Please enter the 4 digit valid OTP"    
            }

            if(!data.password?.trim()){
                errors.password = "Password required"
            }
            if(!data.confirmPassword?.trim()){
                errors.confirmPassword = "ConfirmpPassword required"
            }
            if(data.password !== data.confirmPassword){
                errors.password = "Confirm password value does not match"
                errors.confirmPassword = "Confirm password value does not match"
            }
        }
        return errors
    },
    isValidEmail(email){
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email)
    },
    isOnlyNumbers(otp){
        const numRegex = /^[0-9]+$/
        return numRegex.test(otp)
    }
}